const toAmount = (value) => {
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : 0;
};

export const roundCurrency = (value) =>
  Math.round((toAmount(value) + Number.EPSILON) * 100) / 100;

export const calculateMemberCreditSale = ({
  packageDue,
  availableCredit,
  creditToUse,
  physicalPayment,
}) => {
  const due = Math.max(roundCurrency(packageDue), 0);
  const available = Math.max(roundCurrency(availableCredit), 0);
  const requestedCredit = Math.max(roundCurrency(creditToUse), 0);
  const physical = Math.max(roundCurrency(physicalPayment), 0);
  const creditUsed = Math.min(requestedCredit, available, due);
  const dueAfterCredit = Math.max(roundCurrency(due - creditUsed), 0);
  const physicalAppliedToPackage = Math.min(physical, dueAfterCredit);
  const advanceCredit = Math.max(
    roundCurrency(physical - physicalAppliedToPackage),
    0
  );
  const receivedForSubscription = roundCurrency(
    creditUsed + physicalAppliedToPackage
  );
  const remainingAmount = Math.max(
    roundCurrency(due - receivedForSubscription),
    0
  );

  return {
    packageDue: due,
    availableCredit: available,
    creditUsed,
    physicalPayment: physical,
    physicalAppliedToPackage,
    advanceCredit,
    receivedForSubscription,
    remainingAmount,
    resultingCredit: roundCurrency(available - creditUsed + advanceCredit),
  };
};
